import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from "../../../custom-components/QMentisBreadCrumb";
import DownloadIcon from "@mui/icons-material/Download";
import { Typography } from "@mui/material";
import { ReactComponent as AutomateIcon } from "../../../../images/automateIcon.svg";
import FullscreenToggle from "../../../custom-components/FullScreenToggle.js";
import ApiDetailsPage from "../../../output-components/api-testing/ApiDetails.js";
import TestCasesforApiTesting from "../../../output-components/api-testing/TestCasesforApiTesting.js";
import APIConfiguration from "../../../output-components/api-testing/APIConfiguration.js";
import ChooseTestCase from "../../../output-components/api-testing/ChooseTestCase.js";
import IntroduceSCHEMA from "../../../output-components/api-testing/IntroduceSCHEMA.js";
import FeatureFile from "../../../output-components/api-testing/FeatureFileAPI.js";
import POJOclasses from "../../../output-components/api-testing/POJOclasses.js";
import APIStepDefinition from "../../../output-components/api-testing/APIStepDefinition.js";
import APITestCaseImported from "../../../output-components/api-testing/APITestCaseImported.js";
import { LoadingModalContext } from "../../ServicePage.js";
import {ReactComponent as GenerateButton} from "../../../../images/generateButton.svg"
import { generateFeatureFileToolCalling, pojoClasstWithToolCalling,xmlPojoclassWithToolCalling,apiStepDefinitionToolCalling } from "../../../../services/webServices.js";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SuccessPopup from "../../../output-components/test-automation/SuccessPopup.js";



function APIJavaModifiedTestCaseOutputPage() {
  const location = useLocation();
  const navigate = useNavigate();

//   const [apiDetails, setApiDetails] = useState({});
   const [testCasesapi, setTestCaseAPI] = useState([]);
//   const [ConfigData, setConfigData] = useState({});
  const [framework, setFramework] = useState("");
  const [selectedTestCase, setselectedTestCase] = useState({});
  const [featureFile, setfeatureFile] = useState("");
  const [featureFileData, setFeatureFileData] =  useState(null);
  const [pojoClass, setPojoClass] = useState([]);
  const [payloadSchema, setPayloadSchema] = useState({});
  const [stepDefinition, setStepDefinition] = useState([]);
  const [confirmed, setConfirmed] = useState(false);
  const [projectType, setProjectType]= useState("");
      const {setLoadingState} = useContext(LoadingModalContext);
      const [testdata, settestdata] = useState(`
          package test;
          import io.cucumber.testng.AbstractTestNGCucumberTests;
          import io.cucumber.testng.CucumberOptions;
          @CucumberOptions(features = "src/test/resources/features",
                       glue = "gluecode",
                       plugin = {"pretty", "html:target/cucumber-reports.html", "json:target/cucumber.json"},
                       tags = "@smoketest")
          public class TestRunner extends AbstractTestNGCucumberTests
          {  
          }`
        );
         const [openSuccessPopup, setOpenSuccessPopup] = useState(false);
       
      

      //introduce schema update

   const [schemaType, setSchemaType] = useState("JSON");
    const [fileContentJson, setFileContentJson] = useState(null);
     const [fileContentXml, setFileContentXml] = useState(null);
      const [pojoDataJson, setPojoDataJson] = useState(null);
       const [pojoDataXml, setPojoDataXml] = useState(null);
       const [pojoClasses, setPojoClasses] = useState(null);
       const [stepDefinitionData, setStepDefinitionData] = useState([]);

  

  useEffect(() => {
   

     setTestCaseAPI(location.state?.testCaseData || []);
     setProjectType(location.state.projectType || []); 
     
    // setConfigData(location.state?.configurationData || {});
    setselectedTestCase(location.state?.selectedTestCaseData || {});
    setfeatureFile(location.state?.featureFileData || "");
    setPojoClass(location.state?.pojoData || "");
  //  setSchemaType(location.state?.schemaType)
    setStepDefinition(location.state?.stepDefinitionData || "");
    setFramework(location.state?.framework || "");
  }, [
     location.state?.testCaseData,
     location.state?.projectType,
    // location.state?.configurationData,
    location.state?.selectedTestCaseData,
    location.state?.featureFileData,
    location.state?.pojoData,
   // location.state?.schemaType,
    location.state?.stepDefinitionData,
    location.state?.framework,
  ]);




  const breadCrumbs = [
    // {
    //   title: "API Details",
    //   status: testCasesapi.length > 0 ? "Completed" : "In Progress",
    // },
    // {
    //   title: "Test Case",
    //   status:
    //     testCasesapi.length === 0 
    //       ? "Not Started"
    //       : testCasesapi.length === 0  && Object.entries(ConfigData).length === 0 
    //         ? "In Progress"
    //         : testCasesapi.length > 0   
    //           ? "Completed"
    //           : "Not Started",
    // },
    // {
    //   title: "Configuration",
    //   status:
    //     Object.keys(ConfigData).length === 0
    //       ? "Not Started"
    //       : ConfigData.APIFramework === "" && testCasesapi.length > 0 && Object.entries(ConfigData).length > 0 
    //         ? "In Progress"
    //         : ConfigData.APIFramework !== "" && testCasesapi.length > 0 && Object.entries(ConfigData).length > 0
    //           ? "Completed"
    //           : "In Progress",
    // },
    {
      title: "Test case Imported",
      status: "Completed"
        // (Object.keys(selectedTestCase).length > 0 && testCasesapi.length > 0)
        //   ? "Completed"
        //   : ( testCasesapi.length > 0)
        //     ? "In Progress"
        //     : "Not Started",
    },
    {
      title: "Feature File",
      status:
        Object.keys(selectedTestCase).length > 0 && featureFile !== "" 
          ? "Completed"
          : featureFile === "" && Object.keys(selectedTestCase).length > 0
            ? "In Progress"
            : featureFile === "" && Object.keys(selectedTestCase).length === 0
              ? "Not Started"
              : "Not Started",
    },
    {
      title: "Introduce Schema",
      status:
        pojoClass !== "" || stepDefinition !== "" 
          ? "Completed"
          : pojoClass === "" && featureFile !== "" && confirmed
            ? "In Progress"
            : "Not Started",
    },
    {
      title: "POJO Classes",
      status:
        pojoClass !== "" 
          ? "Completed"
          : pojoClass === ""  
            ? "Not Started"
            : "Not Started",
    },
    {
      title: "Step Definition",
      status:
        stepDefinition !== ""
          ? "Completed"
          : stepDefinition === "" && pojoClass !== ""
            ? "Not Started"
            : "Not Started",
    },
  ];



  const handleGenerateFeatureFile = async () => {
      let fake;
      const startProgress = (setProgress) => {
        let progress = 0;
        let stop = false;
        let finalMessageShown = false;
  
        const interval = setInterval(() => {
          if (stop) return;
  
          progress += 2.4;
          if (progress >= 98 && !finalMessageShown) {
            finalMessageShown = true;
            setLoadingState((prev) => ({
              ...prev,
              message: "Almost done! Fetching your output",
            }));
          }
  
          if (progress >= 98) progress = 98;
  
          setProgress((prev) => ({
            ...prev,
            progress: Math.max(prev.progress, Math.floor(progress)),
          }));
        }, 200);
  
        return {
          stop: () => {
            stop = true;
            clearInterval(interval);
          },
          completeTo100: async () => {
            stop = true;
            clearInterval(interval);
  
            // Rush to 100%
            setProgress((prev) => ({
              ...prev,
              progress: 100,
            }));
            await new Promise((res) => setTimeout(res, 500));
          },
        };
      };
  
      const finishTo100AndClose = async () => {
        await fake.completeTo100();
        setLoadingState({ open: false, message: "", progress: null });
      };
      // Initial message
      setLoadingState({
        open: true,
        message: "Generating Feature File",
        progress: 0,
      });
  
      fake = startProgress(setLoadingState);
  
      try {
        const featureData = await generateFeatureFileToolCalling(
          testCasesapi
        );
        const featureFileData = featureData.data;
        setFeatureFileData(featureFileData);
        await finishTo100AndClose();
        navigate(location.pathname, {
          state: { ...location.state, featureFileData: featureFileData, selectedTestCaseData: testCasesapi },
       });
      } catch (error) {
        console.error("Error generating feature file:", error);
        setLoadingState({ open: false, message: "", progress: null });
      } finally {
        setLoadingState({ open: false, message: "", progress: null });
      }
    };



  
    const handleGeneratePOJO = async () => {
      let fake;
      const startProgress = (setProgress) => {
        let progress = 0;
        let stop = false;
        let finalMessageShown = false;
  
        const interval = setInterval(() => {
          if (stop) return;
  
          progress += 2.2;
          if (progress >= 98 && !finalMessageShown) {
            finalMessageShown = true;
            setLoadingState((prev) => ({
              ...prev,
              message: "Almost done! Fetching your output",
            }));
          }
  
          if (progress >= 98) progress = 98;
  
          setProgress((prev) => ({
            ...prev,
            progress: Math.max(prev.progress, Math.floor(progress)),
          }));
        }, 200);
  
        return {
          stop: () => {
            stop = true;
            clearInterval(interval);
          },
          completeTo100: async () => {
            stop = true;
            clearInterval(interval);
  
            // Rush to 100%
            setProgress((prev) => ({
              ...prev,
              progress: 100,
            }));
            await new Promise((res) => setTimeout(res, 500));
          },
        };
      };
  
      const finishTo100AndClose = async () => {
        await fake.completeTo100();
        setLoadingState({ open: false, message: "", progress: null });
      };
      // Initial message
      setLoadingState({
        open: true,
        message: "Generating Pojo Classes",
        progress: 0,
      });
  
      fake = startProgress(setLoadingState);
      try {
        if (schemaType === "JSON") {
          const responsejson = await pojoClasstWithToolCalling(
            fileContentJson,
            framework
          );
          setPojoDataJson(responsejson.data);
          setPojoClasses(responsejson.data);
         
          await finishTo100AndClose();
          navigate(location.pathname, {
            state: {
              ...location.state,
              pojoData: responsejson.data,
              stepDefinitionData: "",
              // confirmed: false
             // schemaType: schemaType
            },
            replace: true,
          });
        } else if (schemaType === "XML") {
          const responsexml = await xmlPojoclassWithToolCalling(fileContentXml, framework);
          setPojoDataXml(responsexml.data);
          setPojoClasses(responsexml.data);
          
          navigate(location.pathname, {
            state: {
              ...location.state,
              pojoData: responsexml.data,
              stepDefinitionData: "",
             // schemaType : schemaType
              // confirmed : false
            },
            replace: true,
          });
        }
      } catch (error) {
        console.error("Error generating POJO classes:", error);
        setLoadingState({ open: false, message: "", progress: null });
      } finally {
        setLoadingState({ open: false, message: "", progress: null });
      }
    };
  
    const handleGenerateStepDefinition = async () => {
  
      setPojoClasses("")
      
      let fake;
      const startProgress = (setProgress) => {
        let progress = 0;
        let stop = false;
        let finalMessageShown = false;
  
        const interval = setInterval(() => {
          if (stop) return;
  
          progress += 1.5;
          if (progress >= 98 && !finalMessageShown) {
            finalMessageShown = true;
            setLoadingState((prev) => ({
              ...prev,
              message: "Almost done! Fetching your output",
            }));
          }
  
          if (progress >= 98) progress = 98;
  
          setProgress((prev) => ({
            ...prev,
            progress: Math.max(prev.progress, Math.floor(progress)),
          }));
        }, 200);
  
        return {
          stop: () => {
            stop = true;
            clearInterval(interval);
          },
          completeTo100: async () => {
            stop = true;
            clearInterval(interval);
  
            // Rush to 100%
            setProgress((prev) => ({
              ...prev,
              progress: 100,
            }));
            await new Promise((res) => setTimeout(res, 500));
          },
        };
      };
  
      const finishTo100AndClose = async () => {
        await fake.completeTo100();
        setLoadingState({ open: false, message: "", progress: null });
      };
      // Initial message
      setLoadingState({
        open: true,
        message: "Generating Step Definition",
        progress: 0,
      });
  
      fake = startProgress(setLoadingState);
      try {
        const response = await apiStepDefinitionToolCalling({
          featureFileGenerated: featureFile,
  
        }, framework);

        setStepDefinitionData(response.data);
        await finishTo100AndClose();
  
        navigate(location.pathname, {
          state: { ...location.state, stepDefinitionData: response.data, pojoData: "", },
        });
  
      } catch (error) {
        console.error("Error generating step definition:", error);
        setLoadingState({ open: false, message: "", progress: null });
      } finally {
        setLoadingState({ open: false, message: "", progress: null });
      }
    };

     const handleStepDefinition = async () => {
        let fake;
        const startProgress = (setProgress) => {
          let progress = 0;
          let stop = false;
          let finalMessageShown = false;
    
          const interval = setInterval(() => {
            if (stop) return;
    
            progress += 1.5 ;
            if (progress >= 98 && !finalMessageShown) {
              finalMessageShown = true;
              setLoadingState((prev) => ({
                ...prev,
                message: "Almost done! Fetching your output",
              }));
            }
    
            if (progress >= 98) progress = 98;
    
            setProgress((prev) => ({
              ...prev,
              progress: Math.max(prev.progress, Math.floor(progress)),
            }));
          }, 200);
    
          return {
            stop: () => {
              stop = true;
              clearInterval(interval);
            },
            completeTo100: async () => {
              stop = true;
              clearInterval(interval);
    
              // Rush to 100%
              setProgress((prev) => ({
                ...prev,
                progress: 100,
              }));
              await new Promise((res) => setTimeout(res, 500));
            },
          };
        };
    
        const finishTo100AndClose = async () => {
          await fake.completeTo100();
          setLoadingState({ open: false, message: "", progress: null });
        };
        // Initial message
        setLoadingState({
          open: true,
          message: "Generating Step Definition",
          progress: 0,
        });
    
        fake = startProgress(setLoadingState);
        try {
          const response = await apiStepDefinitionToolCalling({
            featureFile: featureFile,
            pojoClass: pojoClasses,
          }, framework);
          setStepDefinitionData(response.data);
          await finishTo100AndClose();
    
          navigate(location.pathname, {
            state: { ...location.state, stepDefinitionData: response.data },
          });
        } catch (error) {
          console.error("Error fetching step definition:", error);
          setLoadingState({ open: false, message: "", progress: null });
        } finally {
          setLoadingState({ open: false, message: "", progress: null });
        }
      };

    const handleMavenProject = async () => {
      try {
        // Define folder structure
        const zip = new JSZip();
  
        // Create nested folders
        const gluecodeFolder = zip.folder("src/test/java/gluecode");
        const pojosFolder = zip.folder("src/test/java/pojo");
        const testsFolder = zip.folder("src/test/java/test");
        const utilitiesFolder = zip.folder("src/test/java/utilities");
        const featureFileFolder = zip.folder("src/test/resources/features");
        const sourcesFolder = zip.folder("src/test/resources/sources");
  
        // Add a files in java folder
        // Loop through and add each file
        stepDefinition.forEach(fileObj => {
          const [fileName, fileContent] = Object.entries(fileObj)[0];
          gluecodeFolder.file(`${fileName}.java`, fileContent);
        });
       // gluecodeFolder.file("gluecode.java", props.stepDefinitionData);
       // pojosFolder.file("pojos.java", props.pojoClassData);
       if (pojoClass && pojoClass.length > 0) {
        pojoClass.forEach(fileObj => {
          const [fileName, fileContent] = Object.entries(fileObj)[0];
          pojosFolder.file(`${fileName}.java`, fileContent);
        });
      } else {
        pojosFolder.file("pojos.java", "");
       } // Add an empty file if no
        testsFolder.file("TestRunner.java", testdata);
        utilitiesFolder.file("PropertiesFileUtility.java", "")
  
        // Adding files in resources folder
        featureFileFolder.file("featureFile.feature", featureFile)
  
        // Add pom.xml at the root level (same as src)
        zip.file("pom.xml", `<project xmlns="http://maven.apache.org/POM/4.0.0" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://maven.apache.org/POM/4.0.0 http://maven.apache.org/xsd/maven-4.0.0.xsd">
  <modelVersion>4.0.0</modelVersion>
  <groupId>org.company</groupId>
  <artifactId>org.apitestingproject</artifactId>
  <version>0.0.1-SNAPSHOT</version>
  <dependencies>
  <!-- for RestAssured jars -->
  <dependency>
  <groupId>io.rest-assured</groupId>
  <artifactId>rest-assured</artifactId>
  <version>5.4.0</version>
  </dependency>
  <!-- for Jackson JSON jars -->
  <dependency>
  <groupId>com.fasterxml.jackson.core</groupId>
  <artifactId>jackson-databind</artifactId>
  <version>2.15.2</version>
  </dependency>
  <!-- for Jackson XML jars -->
  <dependency>
  <groupId>com.fasterxml.jackson.dataformat</groupId>
  <artifactId>jackson-dataformat-xml</artifactId>
  <version>2.15.2</version>
  </dependency>
  <dependency>
  <groupId>jakarta.xml.bin</groupId>
  <artifactId>jakarta.xml.bind-api</artifactId>
  <version>3.0.1</version>
  </dependency>
  <!-- JAXB Runtime -->
    <dependency>
      <groupId>org.glassfish.jaxb</groupId>
      <artifactId>jaxb-runtime</artifactId>
      <version>3.0.2</version>
    </dependency>
  <!-- Cucumber Core -->
  <dependency>
    <groupId>io.cucumber</groupId>
    <artifactId>cucumber-java</artifactId>
    <version>7.14.0</version>
  </dependency>
  
  <!-- Cucumber TestNG Integration -->
  <dependency>
    <groupId>io.cucumber</groupId>
    <artifactId>cucumber-testng</artifactId>
    <version>7.14.0</version>
  </dependency>
  
  <!-- Cucumber Reporting  -->
     <dependency>
      <groupId>net.masterthought</groupId>
      <artifactId>cucumber-reporting</artifactId>
      <version>5.7.5</version>
    </dependency>

  <!-- Gherkin parser  -->
  <dependency>
    <groupId>io.cucumber</groupId>
    <artifactId>gherkin</artifactId>
    <version>26.0.0</version>
  </dependency>
  
  <!-- for TDD(Test Driven Development) framework using TestNG -->
  <dependency>
  <groupId>org.testng</groupId>
  <artifactId>testng</artifactId>
  <version>7.9.0</version>
  </dependency>
  <!-- for normal JSON packing and Unpacking-->
  <dependency>
  <groupId>org.json</groupId>
  <artifactId>json</artifactId>
  <version>20230618</version>
  </dependency>
  </dependencies>
  <build>
  <plugins>
  <plugin>
  <groupId>org.apache.maven.plugins</groupId>
  <artifactId>maven-surefire-plugin</artifactId>
  <version>3.0.0</version>
  <configuration>
  <includes>
  <include>**/*Test.java</include>
  </includes>
  </configuration>
  </plugin>
  <plugin>
  <groupId>org.apache.maven.plugins</groupId>
  <artifactId>maven-compiler-plugin</artifactId>
  <version>3.8.1</version>
  <configuration>
  <source>11</source>
  <target>11</target>
  </configuration>
  </plugin>
  </plugins>
  </build>
  <profiles>
  <profile>
  <id>run-specific-tests</id>
  <build>
  <plugins>
  <plugin>
  <groupId>org.apache.maven.plugins</groupId>
  <artifactId>maven-surefire-plugin</artifactId>
  <version>3.0.0</version>
  <configuration>
  <includes>
  <include>{testClasses}</include>
  </includes>
  </configuration>
  </plugin>
  </plugins>
  </build>
  </profile>
  <profile>
  <id>run-suite-xml</id>
  <build>
  <plugins>
  <plugin>
  <groupId>org.apache.maven.plugins</groupId>
  <artifactId>maven-surefire-plugin</artifactId>
  <version>3.0.0</version>
  <executions>
  <execution>
  <id>execution2</id>
  <goals>
  <goal>test</goal>
  </goals>
  <configuration>
  <suiteXmlFiles>
  <suiteXmlFile>{suiteXmlFile}</suiteXmlFile>
  </suiteXmlFiles>
  </configuration>
  </execution>
  </executions>
  </plugin>
  </plugins>
  </build>
  </profile>
  </profiles>
  </project>`);
        // Generate ZIP
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, "ApiTesting_Project.zip");
          // setTimeout(setOpenSuccessPopup(true), 3000);
        });
        setTimeout(setOpenSuccessPopup(true), 3000);
      } catch (error) {
        console.error("Error during Maven project creation:", error);
      }
    };
  


          const testcaseNextButton = {
      label: "Generate Feature File",
        onClick: handleGenerateFeatureFile,
       // startIcon: <GenerateButton />,
        variant: "contained",
        sx: { float: "right" },

      
  }
 const introduceSchemaNextButton = {

    label: schemaType === "None" ? "Generate Step Definitions111" : "Generate POJO Classes",
        onClick: schemaType === "None" ? handleGenerateStepDefinition : handleGeneratePOJO,
        //startIcon: <GenerateButton />,
        variant: "contained",
        sx: { float: "right" },
        disabled:
         (schemaType === "JSON" && !fileContentJson) ||
    (schemaType === "XML" && !fileContentXml) ||
    (schemaType === "None" && !featureFile), // adjust this last condition as needed
         //disabled: !fileContentJson || !fileContentXml || schemaType === "None",
          
        }

        const pojoclassesNextButton = {
             label: "Generate Step Definition",
            onClick: handleStepDefinition,
            variant: "contained",
           // startIcon: <GenerateButton />,
            sx: { textTransform: "none", float: "right" },
            
  
          }
        
          const stepDefinitionNextButton = {
              label: "Generate Maven Project",
            onClick: handleMavenProject,
            variant: "contained",
            //startIcon: <GenerateButton />,
            sx: { textTransform: "none", float: "right" },
          }
  // const introduceSCHEMANextButton   = () => {
  //   if (schemaType === "None") {
  //         return [
  //           {
  //             label: "Generate Step Definition",
  //             onClick: handleGenerateStepDefinition,
  //             variant: "contained",
  //             startIcon: <GenerateButton />,
  //             sx: { textTransform: "none", float: "right" },
  //             disabled: false,
  //           },
  //         ];
  //       } else {
  //         return [
  //           {
  //             label: "Generate POJO Classes",
  //             onClick: handleGeneratePOJO,
  //             variant: "contained",
  //             startIcon: <GenerateButton />,
  //             sx: { textTransform: "none", float: "right" },
  //             disabled: !fileContentJson || !fileContentXml || schemaType === "None",
  //           },
  //         ];
  //       }
    
  // }

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
        zIndex: 1,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%", // Adjust width when sidebar expands
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
            padding: "0 8px",
            transition: "width 0.3s ease-in-out", // Smooth transition effect
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{
              height: "auto",
              minHeight: "68px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis",
              flexShrink: 1,
              width: "100%",
              maxWidth: "100%",
              transition: "max-width 0.3s ease-in-out", // Adjust when sidebar expands
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
           //   maxWidth: "600px",
            maxWidth: {
                xs: "100%",
                sm: "95vw",
                md: "1100px",
                lg: "1100px",
              },
              paddingBottom: "3vh",
              margin: "10px auto",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate a comprehensive test cases with API details
                </Typography>
              </Box>
              <FullscreenToggle />
            </Box>

            {/* Rendering of all the files based on conditions */}

            {/* {Object.entries(apiDetails).length === 0 && (
              <ApiDetailsPage
                generateTestCasesData={testCasesapi}
                setTestCaseAPI={setTestCaseAPI}
              />
            )}
            {testCasesapi.length > 0 && (
              <TestCasesforApiTesting
                generateTestCasesData={testCasesapi}
                setTestCaseAPI={setTestCaseAPI}
                setConfigData={setConfigData}
              />
            )} */}

        

        {Object.entries(testCasesapi).length !== 0 && (
                <APITestCaseImported
                 generateTestCasesData={testCasesapi}
                   setTestCaseAPI={setTestCaseAPI}
                   featureFile = {featureFile}
                   framework={framework}
                   testcaseNextButton = {testcaseNextButton}
                   projectType={projectType}
                />
              )}

          
            {Object.entries(featureFile).length > 0 && (
              <FeatureFile
                featureFileData={featureFile}
                setfeatureFile={setfeatureFile}
                confirmed={confirmed}
                setConfirmed={setConfirmed}
                framework={framework}
                projectType={projectType}
              />
            )}
            {(pojoClass.length >0 || confirmed || stepDefinition.length > 0) && (
              <IntroduceSCHEMA pojoClass={pojoClass} confirmed = {confirmed} framework={framework} featureFileData = {featureFile} schemaType={schemaType}
              setSchemaType= {setSchemaType} setFileContentJson = {setFileContentJson} setFileContentXml = {setFileContentXml}
              pojoClasses = {pojoClasses} stepDefinitionData = {stepDefinitionData} introduceSchemaNextButton = {introduceSchemaNextButton}
              />
            )}
             {/* {confirmed && <IntroduceSCHEMA confirmed={confirmed} />}  */}

            {pojoClass.length > 0 && (
              <POJOclasses
                pojoData={pojoClass}
                setPojoData={setPojoClass}
                featureFileData={featureFile}
                framework={framework}
                projectType={projectType}
                stepDefinitionData = {stepDefinition}
                 pojoclassesNextButton = {pojoclassesNextButton}
              />
            )}
            {stepDefinition. length >0 && (
              <APIStepDefinition
                stepDefinitionData={stepDefinition}
                setStepDefinitionData={setStepDefinition}
                pojoClassData={pojoClass}
                featureFileData={featureFile}
                stepDefinitionNextButton = {stepDefinitionNextButton}
                setOpenSuccessPopup = {setOpenSuccessPopup}
                openSuccessPopup = {openSuccessPopup}
               
              />
            )} 

             {/* <TestCasesforApiTesting/> 
         <ChooseTestCase/>
                        <IntroduceSCHEMA/>
                        <FeatureFile/> */}
          </Box>
        </Box>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
}

export default APIJavaModifiedTestCaseOutputPage;
